import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../ga4';

/**
 * Hook to track page views in Google Analytics 4
 * Automatically tracks route changes in React Router
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or use pathname as fallback
    const pageTitle = document.title || location.pathname;
    
    // Track page view with full path
    trackPageView(location.pathname + location.search, pageTitle);
    
  }, [location]);
};
